import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cannotProperlyDisplayPlateWells: {
    id: 'cannotProperlyDisplayPlateWells',
    defaultMessage: 'Your uploaded file data is stale. ' +
      'This may be caused by page refreshes or by landing unintentionally on this page. ' +
      'Please reupload your file.'
  },
});

export default messages;
